import React, { useEffect } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles(theme => ({
    dialog: {
        '& .MuiFormControl-root' : {
            minWidth: 420,
            maxWidth: '100%',
        }
    },
    formControl: {
        marginBottom: 0,
        marginRight: 2,
        '& .MuiRadio-root': {
            paddingTop: 4,
            paddingBottom: 4,
        },
        '& .MuiFormControlLabel-label': {
            flexGrow: 1,
        }
    },
    coupleBalance: {
        textAlign: 'right'
    },
}));

const CoupleControl = (props) => {
    const {
        couple
    } = props;

    const classes = useStyles();

    return (
        <Grid container spacing={1} direction="row" justify="space-between">
            <Grid item>{couple.bride_last_name}, {couple.bride_first_name} and {couple.groom_last_name}, {couple.groom_first_name}</Grid>
            <Grid className={classes.coupleBalance} item>{`$${couple.balance}`}</Grid>
        </Grid>
    )
}

const CouplePickerDialog = (props) => {
    const {
        open,
        handleClose,
        handleNextButtonClick,
    } = props;

    const classes = useStyles();

    const [couples, setCouples] = React.useState([]);
    const [couples2, setCouples2] = React.useState([]);
    useEffect(() => {
        if (!open) return;

        new Promise((resolve, reject) => {
            fetch('/api/couples-list')
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setCouples(result);
                    setCouples2(result);
                    resolve();
                })
        });
    }, [open]);

    const [searchState, setSearchState] = React.useState('');

    const handleModalClose = () => {
        setSearchState('');
        handleClose();
    }

    const [nextButtonDisabled, setNextButtonDisabled] = React.useState(true);

    const [value, setValue] = React.useState('');
    const handleChange = event => {
        setNextButtonDisabled(false);
        setValue(parseFloat(event.target.value));
    };

    const handleChoose = event => {
        const matchedCouple = couples.filter(val => {
            return val.id === value
        });
        if (!matchedCouple.length === 1) {
            alert('Something went wrong. Please try again.');
            return;
        }
        handleModalClose();
        handleNextButtonClick(matchedCouple[0]);
    }

    const handleSearch = (event) => {
        setSearchState(event.target.value);
        const text = event.target.value.toLowerCase();
        const searchResult = couples2.filter(x => x.bride_full_name.toLowerCase().indexOf(text) > -1 || x.groom_full_name.toLowerCase().indexOf(text) > -1);
        setCouples(searchResult);
    }

    return (
        <Dialog
            open={open}
            onClose={handleModalClose}
            maxWidth='lg'
            aria-labelledby="couple-picker-title"
        >
            <DialogTitle id="couple-picker-title">Choose a couple</DialogTitle>
            <DialogContent dividers={true} className={classes.dialog}>
                {(couples.length > 0 || searchState !== '') && (
                    <React.Fragment>
                        <Box>
                            <TextField
                                id="couple-list-search"
                                value={searchState}
                                onChange={handleSearch}
                                placeholder="Bride or Groom name"
                                fullWidth
                                InputProps={{
                                    startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
                                }}
                            />
                        </Box>
                        <Box>
                            <FormControl component="fieldset" margin="dense">
                                <RadioGroup aria-label="couple" name="couple" value={value} onChange={handleChange}>
                                    {couples.length > 0 && couples.map(row => (
                                        <FormControlLabel
                                            key={`couple-${row.id}`}
                                            value={row.id}
                                            control={<Radio />}
                                            className={classes.formControl}
                                            label={<CoupleControl couple={row} />}
                                        />
                                    ))}
                                </RadioGroup>
                            </FormControl>
                        </Box>
                    </React.Fragment>
                )}
                {!(couples.length > 0 || searchState !== '') &&
                    <Box textAlign="center" >
                        <CircularProgress />
                    </Box>
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={handleModalClose} variant="contained">
                    Cancel
                </Button>
                <Button onClick={handleChoose} variant="contained" color="primary" disabled={nextButtonDisabled}>
                    Next
                </Button>
            </DialogActions>
        </Dialog>
    )
};

export default CouplePickerDialog;
